import { OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '../../services/translate/translate.service';
import * as _ from 'lodash';
import { MetaService } from '../../services/meta/meta.service';

@Pipe({
  name: 'translate'
})
export class TranslatePipe implements PipeTransform, OnDestroy {

  readySubscription: any;

  constructor(private translate: TranslateService, private meta: MetaService) {
  }

  transform(value: string, variables?: any[]): Promise<string> {
    return new Promise(resolve => {
      this.readySubscription = this.translate.$ready.subscribe(ready => {
        if (!ready) {
          return;
        }
        let translationString = this.translate.get(value);
        const overwrites = this.meta.get('ibexTouch.translationOverwrites');
        if (overwrites && overwrites[this.translate.getCurrentLanguage()] && _.get(overwrites[this.translate.getCurrentLanguage()], value)) {
          translationString = _.get(overwrites[this.translate.getCurrentLanguage()], value);
        }

        if (translationString && variables && variables.length) {
          for (const variable of variables) {
            if (variable.forceTranslation && translationString === value) {
              return '';
            }
            /* replace $var in translation string with dynamic value */
            if (variable && translationString.indexOf('$var') > -1) {
              let replacement = variable.text;
              if (variable.translationString) {
                replacement = this.translate.get(variable.translationString);
              }
              translationString = translationString.replace(/\$var/, replacement);
            }

            /* replace $l and $-l in translation string with dynamic url */
            if (variable && translationString.indexOf('$l') > -1) {
              const blank = variable.blank ? 'target="_blank"' : '';
              let replacement = [];
              if (variable.link) {
                replacement = ['<a href="' + variable.link + '"' + blank + '>', '</a>'];
              }
              if (variable.dataHref) {
                const dataHrefs = [];
                if (typeof variable.dataHref === 'object') {
                  for (const key in variable.dataHref) {
                    if (variable.dataHref[key]) {
                      dataHrefs.push('data-' + key + '="' + variable.dataHref[key] + '"');
                    }
                  }
                }
                const dataHref = dataHrefs.length ? dataHrefs.join(' ') : 'data-href="' + variable.dataHref + '"';
                replacement = ['<a ' + dataHref + '>', '</a>'];
              }
              if (replacement.length) {
                translationString = translationString.replace(/\$l/, replacement[0]).replace(/\$-l/, replacement[1]);
              }
            }
          }
        }
        return resolve(translationString);
      });
    });
  }

  ngOnDestroy() {
    this.readySubscription.unsubscribe();
  }
}
